import { getStore } from "app/store/store"
import { IDsp } from "dsp/model"
import { dspRPO } from "dsp/repository"
import { normalizeSync } from "normalize-diacritics"

export const getAllDsp = (): Promise<IDsp[]> => dspRPO.getAllDsp()

export const searchDspByName = (name?: string): Promise<IDsp[]> => dspRPO.getAllDsp(name)

export const searchDspByNameInStore = (name?: string): IDsp[] => {
  if (!name) {
    return getStore().getState().dsp.dsps.slice()
  }
  const normalizedName = normalizeSync(name).toLowerCase()
  return getStore()
    .getState()
    .dsp.dsps.filter(d => normalizeSync(d.name).toLowerCase().indexOf(normalizedName) !== -1)
}

export const getDspNameById = (dspId: number | null): string => {
  const dsp = getStore()
    .getState()
    .dsp.dsps.find(d => d.id)
  if (!dsp) {
    return "-"
  }
  return dsp.name || "no name"
}
